define('C3.ShoppingExtensions.ViewInventory.ResultsView'
, 	[
		'c3_shoppingextensions_viewinventory_resultsview.tpl',
        'Profile.Model',
        //'SC.Configuration',
        'Utils',    
		'SCView',
        'C3.ShoppingExtensions.IncomingEquipment.Collection'
	],
function (
		c3_shoppingextensions_viewinventory_resultsview_tpl,
        ProfileModel,
       // Configuration,
        Utils,
		SCViewModule,
        IncomingEquipmentCollection
){
	'use strict';

	 var SCView = SCViewModule.SCView;

	  function ViewInventoryResultsView (options) {
        SCView.call(this, options);

        this.template = c3_shoppingextensions_viewinventory_resultsview_tpl;
        this.options = options;
	    this.model = options.model;

    }

    ViewInventoryResultsView.prototype = Object.create(SCView.prototype);
    ViewInventoryResultsView.prototype.constructor = ViewInventoryResultsView;


    ViewInventoryResultsView.prototype.render = function () {
        SCView.prototype.render.call(this);

    }

    ViewInventoryResultsView.prototype.getContext = function () {

        return {
        	ColumnValues : this.model.get('columns')
        }
    }

    return ViewInventoryResultsView
});
